import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="time-select"
// NOTE: For future use a moment.js kind of library. [day.js](https://day.js.org/) or [date-fns](https://date-fns.org/)
export default class extends BaseRailsRequestController {
  static targets = ["start", "end"];

  static values = {
    minimumTime: String,
    maximumTime: String,
    startSelected: Boolean,
    endSelected: Boolean,
    greaterThanStartErrorMessage: String,
    notWithinRangeErrorMessage: String,
  };

  connect() {
    if (this.hasMinimumTimeValue) {
      this.startTimeInstance = this.createDateInstance(this.minimumTimeValue);
    }
    if (this.hasMaximumTimeValue) {
      this.endTimeInstance = this.createDateInstance(this.maximumTimeValue);
    }

    this.previousStartValue = this.startTarget.value;
    this.previousEndValue = this.endTarget.value;

    this.updateDisabledOptions();
    this.initializeDefaultValues();
  }

  createDateInstance(time) {
    const timeParts = time.split(":");
    const timeInstance = new Date();

    timeInstance.setHours(timeParts[0], timeParts[1], 0, 0);

    return timeInstance;
  }

  isTimeWithinAllowedRange(time) {
    const hasTimeRange = this.hasMinimumTimeValue && this.hasMaximumTimeValue;
    return !hasTimeRange || (time >= this.startTimeInstance && time <= this.endTimeInstance);
  }

  initializeDefaultValues() {
    if (!this.hasStartSelectedValue) {
      const firstAvailable = this.startTarget.querySelector("option:not([disabled])");

      if (firstAvailable) {
        this.startTarget.value = firstAvailable.value;
      }
    }

    if (!this.hasEndSelectedValue) {
      const options = this.endTarget.querySelectorAll("option:not([disabled])");
      const lastAvailable = options[options.length - 1];

      if (lastAvailable) {
        this.endTarget.value = lastAvailable.value;
        this.endTarget.dispatchEvent(new Event("change")); // We need to do this to update the first select disabled options
      }
    }
  }

  updateDisabledOptions() {
    const startTimeInstance = this.createDateInstance(this.startTarget.value);
    const endTimeInstance = this.createDateInstance(this.endTarget.value);

    this.endTarget.querySelectorAll("option").forEach((option) => {
      const time = this.createDateInstance(option.value);
      option.disabled = time <= startTimeInstance || !this.isTimeWithinAllowedRange(time);
    });

    this.startTarget.querySelectorAll("option").forEach((option) => {
      const time = this.createDateInstance(option.value);
      option.disabled = time >= endTimeInstance || !this.isTimeWithinAllowedRange(time);
    });
  }

  validateSelection() {
    const startTimeInstance = this.createDateInstance(this.startTarget.value);
    const endTimeInstance = this.createDateInstance(this.endTarget.value);

    if (!this.isTimeWithinAllowedRange(startTimeInstance)) {
      this.startTarget.value = this.previousStartValue;
      window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.notWithinRangeErrorMessageValue } }));
      return;
    }

    if (startTimeInstance >= endTimeInstance) {
      this.startTarget.value = this.previousStartValue;
      this.endTarget.value = this.previousEndValue;
      window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.greaterThanStartErrorMessageValue } }));
      return;
    }

    this.updateDisabledOptions();

    this.previousStartValue = this.startTarget.value;
    this.previousEndValue = this.endTarget.value;
  }
}
